import React, { useState } from "react";
import Layout from "../../CommonComponents/Layout/Layout";
import { StepIndicator } from "./Messaging/StepIndicator/StepIndicator";
import IOSNotificationForm from "./Messaging/IOSNotificationForm/IOSNotificationForm";

import "./stylesNewPromotion.css";
import { AppleIcon, MailIcon, PlusIcon } from "./Icons";
import IOSNotificationPreview from "./Messaging/IOSNotificationForm/IOSNotificationPreview/IOSNotificationPreview";
import EmailNotificationForm from "./Messaging/EmailNotificationForm/EmailNotificationForm";
import EmailNotificationPreview from "./Messaging/EmailNotificationForm/EmailNotificationPreview/EmailNotificationPreview";
import PromoNotificationForm from "./Messaging/PromoNotificationForm/PromoNotificationForm";
import PromoNotificationPreview from "./Messaging/PromoNotificationForm/PromoNotificationPreview/PromoNotificationPreview";
import TargetAudiences from "./TargetAudiences/TargetAudiences";
import ScheduleDelivery from "./ScheduleDelivery/ScheduleDelivery";
import Summary from "./Summary/Summary";

function NewPromotion() {
  const [navItems, setNavItems] = useState([
    { id: 1, label: "E-mail" },
    { id: 2, label: "IOS Push" },
    { id: 3, label: "Promo" },
  ]);
  const [activeNavItem, setActiveNavItem] = React.useState(navItems[0].label);
  const [stepIndicators, setStepIndicators] = useState([
    { id: 1, label: "Messaging", isActive: true },
    { id: 2, label: "Target Audiences", isActive: false },
    { id: 3, label: "Schedule Delivery", isActive: false },
    { id: 4, label: "Summary", isActive: false },
  ]);

  const activeStep = stepIndicators.find((step) => step.isActive).id;

  const [notificationData, setNotificationData] = useState({
    title: "Pay 1- Get X2. Get +100% on your Rebet Cash Bundle!",
    description: "Unlock Savings on Rebet Cash Purchase!",
    dateTime: "Apr 20, 2025 at 9:12 PM",
    timeLeft: "2d 1h left",
  });

  const [activePromoVariant, setActivePromoVariant] = useState("Purchase Match");

  return (
    <Layout>
      <div className="promotions-management-container">
        <div className="new-promotion promotions-management">
          <main className="wizardContainer">
            <header className="wizardHeader">
              {stepIndicators.map((step) => (
                <StepIndicator
                  key={step.id}
                  number={step.id}
                  label={step.label}
                  isActive={step.isActive}
                  setStepIndicators={setStepIndicators}
                />
              ))}
            </header>
            {activeStep === 1 && (
              <>
                <nav className="channelBar">
                  <button
                    className={`channelButton ${
                      activeNavItem === "E-mail" ? "channelButtonActive" : ""
                    }`}
                    onClick={() => setActiveNavItem("E-mail")}
                  >
                    <MailIcon />
                    <span>E-mail</span>
                  </button>
                  <button
                    className={`channelButton ${
                      activeNavItem === "IOS Push" ? "channelButtonActive" : ""
                    }`}
                    onClick={() => setActiveNavItem("IOS Push")}
                  >
                    <AppleIcon />
                    <span>IOS Push</span>
                  </button>
                  <button
                    className={`channelButton ${
                      activeNavItem === "Promo" ? "channelButtonActive" : ""
                    }`}
                    onClick={() => setActiveNavItem("Promo")}
                  >
                    Promo
                  </button>
                  <div className="appleIconWrapper"></div>
                  <button className="addChannelButton">
                    <PlusIcon />
                  </button>
                </nav>

                {activeNavItem === "E-mail" && <EmailNotificationForm />}

                {activeNavItem === "IOS Push" && (
                  <IOSNotificationForm
                    setNotificationData={setNotificationData}
                  />
                )}

                {activeNavItem === "Promo" && (
                  <PromoNotificationForm
                    setActivePromoVariant={setActivePromoVariant}
                  />
                )}
              </>
            )}
            {activeStep === 2 && <TargetAudiences />}
            {activeStep === 3 && <ScheduleDelivery />}
            {activeStep === 4 && <Summary />}
          </main>
          {activeStep === 1 && (
            <div className="communication-preview">
              {activeNavItem === "E-mail" && <EmailNotificationPreview />}
              {activeNavItem === "IOS Push" && (
                <IOSNotificationPreview notificationData={notificationData} />
              )}

              {activeNavItem === "Promo" && (
                <PromoNotificationPreview
                  activePromoVariant={activePromoVariant}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}

export default NewPromotion;
